import { ALERTS_STATE } from './constants'
import { IAlertType } from '.'

export interface IAlertsState {
  [ALERTS_STATE]: IAlertType[]
}

const state: IAlertsState = {
  [ALERTS_STATE]: [],
}

export default state
